<div
  class="dropdown"
  [class.dropdown_transparent]="border === 'none'"
  #dropdown
>
  <form class="dropdown__form" [formGroup]="myForm">
    <ng-container *ngIf="!isDaggerDropdown">
      <span class="dropdown__specialization" *ngIf="hasFilter"
        ><i class="icon-vector"></i>Specialization:
      </span>
      <i class="icon-sort" *ngIf="isIconSort"></i>
      <input
        type="text"
        [value]="
          isMultiselect ? multiSelectValue : myForm.controls['radio'].value
        "
        class="dropdown__value"
        [class.dropdown__value_padding-filter]="hasFilter"
        [class.dropdown__value_padding-sort]="isIconSort"
        [class.dropdown__value_classic]="border === 'classic'"
        [class.dropdown__value_blue]="border === 'blue'"
        [class.dropdown__value_invisible]="isValueInvisible"
        [style.cursor]="isEditMode ? 'pointer' : 'auto'"
        (click)="showItems($event)"
        readonly
      />
      <i
        class="icon-arrow"
        [class.icon-arrow_rotate]="visibleContent"
        *ngIf="isEditMode"
      ></i>
      <div
        class="dropdown__show-hide"
        *ngIf="visibleContent"
        [style.maxHeight.px]="displayedOptionsHeight"
      >
        <div class="options">
          <div class="options__filter" *ngIf="isShowFilter">
            <input
              placeholder="Search participants"
              class="filter_input"
              type="text"
              (keyup)="filterItems($event)"
            />
          </div>
          <div
            *ngIf="!isMultiselect"
            class="options__radioBox"
            [style.maxHeight.px]="23 * countItems"
          >
            <div *ngFor="let item of filteredItems; let i = index">
              <input
                type="radio"
                name="radio"
                [id]="'item' + i + radioRandom"
                hidden
                [value]="item"
                formControlName="radio"
              />
              <label [for]="'item' + i + radioRandom">{{ item }}</label>
            </div>
          </div>
          <div
            *ngIf="isMultiselect"
            class="options__multiselect"
            [style.maxHeight.px]="23 * countItems"
          >
            <div
              *ngFor="let item of filteredItems; let i = index; let last = last"
            >
              <label class="label-check">
                <input
                  class="check_input"
                  type="checkbox"
                  [formControlName]="item"
                  (change)="onCheckChange($event)"
                  [value]="item"
                />
                <span class="check_box"></span>
                <span class="checked">{{ item }}</span>
              </label>
            </div>
          </div>
          <span
            class="options__all"
            [class.ml-16]="isMultiselect"
            *ngIf="filteredItems.length > countItems"
            (click)="countItems = filteredItems.length"
            >All</span
          >
        </div>
        <div class="dropdown__all-exept" *ngIf="isMultiselect && hasAllExept">
          <input
            type="checkbox"
            name=""
            id="allExept"
            formControlName="allExept"
          />
          <label for="allExept" (click)="changeAllExept()">All except</label>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isDaggerDropdown">
      <div class="dropdown__autocomplete" (click)="showItems($event)">
        <div
          *ngFor="let item of formArray.value; let index = index"
          class="dropdown__autocomplete-items"
        >
          <div class="dropdown__autocomplete-item">
            <label class="dropdown__autocomplete-label">{{ item }}</label>
            <div class="dropdown__autocomplete__icon">
              <i class="icon-close" (click)="removeItem(index, item)"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="dropdown__show-hide autocomplete"
        [class.all__clicked]="countItems === filteredItems.length"
        *ngIf="visibleContent"
      >
        <div class="options">
          <div class="options__filter" *ngIf="isShowFilter">
            <input
              placeholder="Search participants"
              class="filter_input"
              type="text"
              (keyup)="filterItems($event)"
            />
          </div>
          <div
            class="options__multiselect"
            [style.maxHeight.px]="23 * countItems"
          >
            <div
              *ngFor="let item of filteredItems; let i = index; let last = last"
            >
              <label class="label-check">
                <input
                  class="check_input"
                  type="checkbox"
                  [formControlName]="item"
                  (change)="onCheckChange($event)"
                  [value]="item"
                />
                <span class="check_box"></span>
                <span class="checked">{{ item }}</span>
              </label>
            </div>
          </div>
          <span
            class="options__all ml-16"
            *ngIf="filteredItems.length > countItems"
            (click)="countItems = filteredItems.length"
            >All</span
          >
        </div>
        <div class="dropdown__all-exept" *ngIf="hasAllExept">
          <input
            type="checkbox"
            name=""
            id="allExept"
            formControlName="allExept"
          />
          <label for="allExept" (click)="changeAllExept()">All exept</label>
        </div>
      </div>
    </ng-container>
  </form>
</div>
